"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResultConfigRasterTo5Scale = exports.getResultConfigRaster = void 0;
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
const colorController = new ColorLibController_1.default();
function getColor(scale, level) {
    return scale === 'hlt' ? colorController.getDiseasesColor(level) : colorController.getRankColor(level);
}
function getResultConfigRaster(scale) {
    return [
        'case',
        ['==', ['band', 2], 0], [0, 0, 0, 0],
        [
            'interpolate', ['linear'], ['band', 1],
            0, getColor(scale, '0'),
            0.000001, getColor(scale, '1'),
            0.199999, getColor(scale, '1'),
            0.2, getColor(scale, '2'),
            0.399999, getColor(scale, '2'),
            0.4, getColor(scale, '3'),
            0.599999, getColor(scale, '3'),
            0.6, getColor(scale, '4'),
            0.799999, getColor(scale, '4'),
            0.8, getColor(scale, '5'),
            1, getColor(scale, '5')
        ]
    ];
}
exports.getResultConfigRaster = getResultConfigRaster;
function getResultConfigRasterTo5Scale(scale) {
    return [
        'interpolate',
        ['linear'],
        ['band', 1],
        0, [0, 0, 0, 0],
        0.00001, getColor(scale, '1'),
        0.59999, getColor(scale, '1'),
        0.6, getColor(scale, '3'),
        0.79999, getColor(scale, '3'),
        0.8, getColor(scale, '5'),
        1, getColor(scale, '5'),
    ];
}
exports.getResultConfigRasterTo5Scale = getResultConfigRasterTo5Scale;
